import { createEditButton } from 'modules/Admin/components'
import { UpsertDeviceModal } from '../UpsertDeviceModal'

export const DeviceEditButton = createEditButton(UpsertDeviceModal, 'things')
